import { render } from "./page-loading-cover.vue?vue&type=template&id=12c486bd"
import script from "./page-loading-cover.vue?vue&type=script&lang=js"
export * from "./page-loading-cover.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__